import { render, staticRenderFns } from "./RegisterEventAction.vue?vue&type=template&id=386145bb&scoped=true&"
import script from "./RegisterEventAction.vue?vue&type=script&lang=ts&"
export * from "./RegisterEventAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386145bb",
  null
  
)

export default component.exports